/* global $ */

export function fetchPlace(url) {
  return new Promise(resolve => {
    $.get(url, data => resolve(data), 'json');
  });
}

